import { MenuItem as AriaMenuItem } from 'react-aria-menubutton';
import styled from 'styled-components';
import { get } from '../../tools/utils';
const MenuItem = styled(AriaMenuItem) `
  white-space: nowrap;
  padding: ${get.space('xs')};
  cursor: pointer;
  background-color: ${get.colors('white')};
  display: flex;
  text-decoration: none;
  border: none;
  width: 100%;
  border-bottom: 1px solid ${get.colors('slate-3')};

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: ${get.colors('patina-1')};
  }
`;
export default MenuItem;
//# sourceMappingURL=MenuItem.js.map